import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import BoLoader from "../../helpers/BoLoader";
import PendingCloseCardsGrid from "./PendingCloseCardsGrid";

const PendingCloseCards = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [refereshdata, setRefereshdata] = useState(false);

  //Loader
  const [boloader, setBoLoader] = useState(false);

  useEffect(() => {
    setRefereshdata(true);
  }, []);

  return (
    <div className="col-xl-9 col-lg-12 bo-main-content">
      <div className="row ">
        <BoLoader loading={boloader} />
        <div className="col-sm-6">
          <h3>Pending Close Cards</h3>
        </div>
      </div>

      <div>
        {refereshdata && (
          <div>
            <PendingCloseCardsGrid
              methodname="pendingclosecards"
              placeholdervalue="Search"
              headersdata={[
                "CLIENT NAME",
                "TOKEN ID",
                "BALANCE",
                "STATUS",
                "DESCRIPTION",
                "CREATED DATE",
              ]}
              screenname="pendingclosecards"
              refereshpage={setRefereshdata}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingCloseCards;
